<template>
	<div class="mobile-index">
		<mobile-header></mobile-header>
		<div class="main-con">
			<div class="banner-con"></div>
			<div class="about-con">
				<div class="say-con">
					<i class="x-icon-left"></i>
					<p>Science and Technology Dream Beyond Imagination</p>
					<i class="x-icon-right"></i>
				</div>
				<div class="desc-con">
					<p>
						Xhorse, as a national level high-tech enterprise based on intelligent manufacturing, has been always exploring new possibilities for intelligent manufacturing and life, and committed to changing life through science and technology.</p>
				</div>
				<div class="slide-con">
					<ul>
						<router-link :to="{
                             name: 'about',
                             params: {
                                 activeLevel1: 1,
                                 activeLevel2: 1
                             }
						}">
							<li class="about-xhorse"><p>About Xhorse</p></li>
						</router-link>
						<router-link :to="{
                             name: 'about',
                             params: {
                                 activeLevel1: 1,
                                 activeLevel2: 7
                             }
						}">
							<li class="address"><p>Address</p></li>
						</router-link>
						<router-link :to="{
                             name: 'join',
                             params: {
                                 activeLevel1: 5,
                                 activeLevel2: 1
                             }
						}">
							<li class="join-us"><p>Join us</p></li>
						</router-link>
					</ul>
				</div>
				<div class="swipe-con">
					<el-carousel :interval="3000"
								 :autoplay="true"
								 arrow="always"
								 indicator-position="none"
								 class="carousel">
						<el-carousel-item v-for="item in swipe" :key="item">
							<div class="swiper-item">
								<div class="swipe-image"><img :src="item.depend" alt="Xhorse"/></div>
								<div class="swipe-txt">
									<h3>{{ item.title }}</h3>
									<ul>
										<li v-for="ls in item.text">
											<template v-if="item.key==1">
												<div class="dot x-flow">·</div>
												<p class="line x-flow">{{ ls }}</p>
											</template>
											<template v-else>{{ ls }}</template>
										</li>
									</ul>
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="join-con">
					<div class="join-image"></div>
					<div class="join-txt">
						<h3>Join Us Now! To be a member of the Xhorse Team.</h3>
						<p>
							To shape your future life. Let's hand in hand, to make the unconstrained dream of science and technology come true!</p>
					</div>
					<div class="join-btns">
						<ul>
							<router-link :to="{ name: 'join' , params: {
							    activeLevel1: 5,
							    activeLevel2: 3
							}}">
								<li>
									<button>
										<div class="abo">Campus Recruitment</div>
										<div class="bot">
											<i class="x-icon-air x-inline"></i>
											<span class="x-inline">Apply Now</span>
										</div>
									</button>
								</li>
							</router-link>
							<router-link :to="{ name: 'join' , params: {
							    activeLevel1: 5,
							    activeLevel2: 2
							}}">
								<li>
									<button>
										<div class="abo">Social Recruitment</div>
										<div class="bot">
											<i class="x-icon-air"></i>
											<span>Apply Now</span>
										</div>
									</button>
								</li>
							</router-link>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<mobile-footer :linkVisible="linkVisible" :applyFooterStyle="applyFooterStyle"></mobile-footer>
	</div>
</template>

<script>
    import swipe_image1 from '@/assets/mobile/resource/images/home/image_home_product_01.png'
    import swipe_image2 from '@/assets/mobile/resource/images/home/image_home_product_02.png'
    import swipe_image3 from '@/assets/mobile/resource/images/home/image_home_product_03.png'
    export default {
        components: {
            MobileHeader: () => import('@/components/mobile/zh-cn/header'),
            MobileFooter: () => import('@/components/mobile/zh-cn/footer'),
        },
        data(){
            return {
                swipe: [
                    {
                        key: 1,
                        depend: swipe_image1,
                        title: "Desktop 5-axis engraving machine",
                        text: [
                            "Support 5-axis vector interpolation RTCP tool tip control;",
                            "Spline curve fairing technology;",
                            "High-speed forward-looking and speed smoothing technology;",
                            "Configure a unique optical scanning module to achieve rapid positioning of the workpiece;"
                        ]
                    },
                    {
                        key: 2,
                        depend: swipe_image2,
                        title: "Smart Electronic Lock",
                        text: ["The Smart Electronic Lock supports fingerprint recognition, password-protected door locking system, WiFi connection, access information record function, and system information configuration. It enables you to remotely open your door by using the cell phone App. The smart electronic lock also has a power detection function, which will promp..."]
                    },
                    {
                        key: 3,
                        depend: swipe_image3,
                        title: "Xhorse ASIC Team",
                        text: ["Use the traditional light source to obtain key parameters such as Key blank shape, biting shape, and, contour. It enables users to greatly improve the speed of the key cutting process."]
                    }
                ],
                linkVisible: true,
                applyFooterStyle: {
                    minHeight: '70.4375rem',
                    background: '#363940'
                }
            };
        },
        mounted(){
            const _this = this;
            _this.$nextTick(() => {
                document.body.style.overflow = 'auto';
            });
        }
    }

</script>

<style scoped="">

	@import '../../../assets/mobile/css/index.css';

</style>


// WEBPACK FOOTER //
// src/components/mobile/zh-cn/index.vue